<template>
  <div>
    <a-modal
      wrap-class-name="report-detail-modal-wrapper"
      width="702px"
      :mask-closable="false"
      :visible="visible"
      :footer="null"
      :title="title"
      @cancel="resetParamsAndCancel"
    >
      <a-row type="flex" class="report-detail-row" :gutter="24">
        <a-col class="report-detail-label" :span="4"> 计划名称 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.work_plan_title }}
        </a-col>
        <a-col class="report-detail-label" :span="4"> 工作量 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.plan_num }}
          <span
            :class="modifyDeployNum >= 0 ? 'badge-red' : 'badge-green'"
            v-if="modifyDeployNum"
            >{{ modifyDeployNum > 0 ? "+" : "" }}{{ modifyDeployNum }}</span
          >
        </a-col>
        <a-col class="report-detail-label" :span="4"> 活动项目 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.service_title }}
        </a-col>
        <a-col class="report-detail-label" :span="4"> 清单金额 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.total_money }}
          <span
            :class="modifyDeployNum >= 0 ? 'badge-red' : 'badge-green'"
            v-if="modifyDeployNum"
            >{{ modifyDeployNum > 0 ? "+" : ""
            }}{{ (data.total_money / data.plan_num) * modifyDeployNum }}</span
          >
        </a-col>
        <a-col class="report-detail-label" :span="4"> 受委托名称 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.name }}
        </a-col>
        <a-col class="report-detail-label" :span="4"> 开始 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.plan_start_time }}
        </a-col>
        <a-col class="report-detail-label" :span="4"> 服务城市 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.province }}
        </a-col>
        <a-col class="report-detail-label" :span="4"> 结束 </a-col>
        <a-col class="report-detail-value" :span="8">
          {{ data.plan_end_time }}
        </a-col>
      </a-row>
      <div class="title">
        调配详情
        <span
          style="
            font-size: 14px;
            font-weight: normal;
            color: rgba(0, 0, 0, 0.65);
          "
        >
          (<a-icon
            type="info-circle"
            style="margin: 0 5px"
          />大于0增加，小于0减少 )
        </span>
      </div>
      <a-row class="report-detail-row" :gutter="24">
        <a-col :span="6"> 姓名 </a-col>
        <a-col :span="5"> 已分配工作量 </a-col>
        <a-col :span="5"> 已完成工作量 </a-col>
        <a-col :span="5"> 调配工作量 </a-col>
      </a-row>
      <a-form class="report-detail-row" :form="form">
        <a-row :gutter="24">
          <div v-for="(item, index) in promoterFormData" :key="item.key">
            <a-col :span="6">
              <a-form-item :colon="false" :wrapper-col="{ span: 24 }">
                <a-select
                  v-decorator="[
                    `${item.key}.uid`,
                    {
                      rules: [{ required: true, message: '请选择推广员' }],
                    },
                  ]"
                  placeholder="选择推广员"
                  :showSearch="true"
                  ref="lastSelectValue"
                  @change="
                    (value, option) => onChangePromoter(value, option, index)
                  "
                >
                  <a-select-option
                    v-for="option in promoterData"
                    :key="option.id"
                    :value="option.id + '_' + option.user_realname"
                    :data-lastval="option.id"
                    :disabled="chkIsSelect(option.id)"
                  >
                    {{ option.user_realname }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :colon="false" :wrapper-col="{ span: 24 }">
                <span ref="hasAssignedNum" class="show-assigned-num"></span>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :colon="false" :wrapper-col="{ span: 24 }">
                <span
                  ref="hasAssignedCompleteNum"
                  class="show-assigned-num"
                ></span>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :colon="false" :wrapper-col="{ span: 24 }">
                <a-input-number
                  v-decorator="[
                    `${item.key}.assigned_num`,
                    {
                      rules: [{ required: true, message: '请输入' }],
                    },
                  ]"
                  placeholder="请输入"
                  @blur="changeNum"
                  @change="changeNum"
                />
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-icon
                v-if="promoterFormData.length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :disabled="promoterFormData.length === 1"
                @click="removePromoter(index)"
              />
            </a-col>
          </div>
          <a-col :span="24">
            <a-button type="dashed" style="width: 100%" @click="addPromoter">
              <a-icon type="plus" /> 添加人选
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <form-button
        style="margin-top: 20px"
        :btn-is-loading="btnIsLoading"
        @onCancel="resetParamsAndCancel"
        @onSubmit="onDeploySubmit"
      />
    </a-modal>
  </div>
</template>

<script>
const uuidv1 = require("uuid/v1");
export default {
  props: ["title", "visible", "data", "btnIsLoading"],
  data() {
    return {
      promoterData: [],
      form: this.$form.createForm(this),
      promoterFormData: [
        {
          key: uuidv1(),
          uid: "",
          has_assigned_num: "",
          has_assigned_complete_num: "",
          assigned_num: "",
        },
      ],
      promoterValue: {},
      selectPromoterIds: [],
      modifyDeployNum: 0,
    };
  },
  computed: {},
  watch: {
    visible: function () {
      // 关闭时清空数据
      if (!this.visible) {
        this.selectPromoterIds = [];
        this.promoterFormData = [
          {
            key: uuidv1(),
            uid: "",
            has_assigned_num: "",
            has_assigned_complete_num: "",
            assigned_num: "",
          },
        ];
      }

      this.modifyDeployNum = 0;
      // 获取推广员
      if (this.$store.state.user.role === 1) {
        this.getPromoterDataDeploy({
          status: "1",
          work_list_id: this.data.data.id,
        });
      }
    },
  },
  mounted() {},
  methods: {
    // 获取推广员
    async getPromoterDataDeploy(params) {
      let result = await this.$http.post(
        "/promoter/getPromoterListForDeploy",
        params
      );
      if (result.data.status === 1) {
        this.promoterData = result.data.data.data_list;
      }
    },
    // 添加人选
    addPromoter() {
      this.promoterFormData.push({
        key: uuidv1(),
        uid: "",
        has_assigned_num: "",
        has_assigned_complete_num: "",
        assigned_num: "",
      });
    },
    // 移除
    removePromoter(key) {
      this.promoterFormData = this.promoterFormData.filter(
        (item, index) => index !== key
      );
      // 去除已分配的推广人
      let lastValue = this.$refs.lastSelectValue[key].value;
      this.selectPromoterIds = this.selectPromoterIds.filter(function (number) {
        return lastValue != number;
      });

      let that = this;
      setTimeout(function () {
        that.changeNum();
      }, 200);
    },
    // 获取
    getTotal(data) {
      let count = 0;
      data.forEach((item) => {
        if (item.assigned_num) {
          count += item.assigned_num;
        }
      });
      return count;
    },
    resetParamsAndCancel() {
      this.modifyDeployNum = 0;
      this.selectPromoterIds = [];
      this.promoterFormData = [
        {
          key: uuidv1(),
          uid: "",
          has_assigned_num: "",
          has_assigned_complete_num: "",
          assigned_num: "",
        },
      ];
      // 执行回调关闭弹窗
      this.$emit("onCancel");
    },
    // 分配推广人执行任务数量
    onChangePromoter(value, option, index) {
      // 去掉姓名
      value = value.substr(0, value.indexOf("_"));
      let that = this;
      this.promoterData.map(function (item) {
        if (item.id == value) {
          that.$refs.hasAssignedNum[index].innerText = item.has_assigned_num;
          that.$refs.hasAssignedCompleteNum[index].innerText =
            item.has_assigned_complete_num;
        }
      });

      let lastValue = this.$refs.lastSelectValue[index].value;
      this.selectPromoterIds.push(value);
      if (lastValue !== undefined) {
        this.selectPromoterIds = this.selectPromoterIds.filter(function (
          number
        ) {
          return lastValue != number;
        });
      }
    },
    // 设置推广人是否已被分配
    chkIsSelect(promoterId) {
      return this.selectPromoterIds.includes(promoterId);
    },
    changeNum() {
      var elements = document.getElementsByClassName("ant-input-number-input");
      var subTotal = 0;
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].value == "") {
          continue;
        }
        subTotal += parseInt(elements[i].value);
      }
      this.modifyDeployNum = subTotal;
    },
    onDeploySubmit() {
      this.$emit("onSubmit");
    },
  },
};
</script>
<style lang="scss" scoped>
.show-assigned-num {
  border: 1px solid #d9d9d9;
  width: 100%;
  display: ruby-text;
  border-radius: 3px;
  margin-top: 5px;
  background: #f5f5f5;
  height: 30px;
  line-height: 30px;
}
.report-detail-modal-wrapper {
  .ant-modal-body {
  }
  .report-detail-row {
    padding: 0 50px;
    &.bottom {
      padding-bottom: 50px;
    }
  }
  .report-detail-label {
    padding: 15px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(195, 199, 213, 1);
  }
  .report-detail-value {
    padding: 15px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
  }
  .title {
    margin: 30px 0;
    color: #2a2947;
    font-weight: 600;
    font-size: 18px;
  }
  .ant-input-number {
    width: 100%;
  }
  .dynamic-delete-button {
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .badge-red {
    padding: 0px 8px;
    background-color: red;
    color: #fff;
    border-radius: 10px;
  }
  .badge-green {
    padding: 0px 8px;
    background-color: rgb(82, 196, 26);
    color: #fff;
    border-radius: 10px;
  }
}
</style>
